// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"10":"4f37d2b4","212":"ef460156","372":"4269f034","696":"4e23d040","980":"c8c8d002"}[chunkId] + ".css";
};